<script>
  import Text from "$lib/Text.svelte";
  import { linkResolver } from "$lib/prismic.js";

  export let block;
</script>

<div class="p-16 {block.primary.background ? 'dark' : 'light'}">
  <div class="max-w-content mx-auto">
    <div class="flex flex-wrap -my-8 -mx-8 lg:-mx-16 xl:-mx-24">
      {#each block.fields as { logo, headline, text, button_link, button_text }}
        <a
          href={button_text
            ? button_link.url || linkResolver(button_link._meta)
            : "#"}
          target={button_link?.target}
          on:click={(e) => {
            if (!button_text) e.preventDefault();
          }}
          class="block group w-full md:w-1/2 {block.primary.columns
            ? 'lg:w-1/4 lg:px-4 xl:px-8'
            : 'lg:w-1/3 lg:px-16 xl:px-24'} py-8 px-8 {!button_text
            ? 'cursor-default'
            : ''}"
        >
          <div class="flex items-center h-24 mb-4">
            <img
              src={logo.url}
              alt="Partner Logo"
              class="block w-full h-full"
            />
          </div>
          <h3 class="font-sans text-2xl font-bold normal-case mb-4">
            {headline}
          </h3>
          <Text {text} />
          {#if button_text}
            <span class="btn mt-4 group-hover:gradient">{button_text}</span>
          {/if}
        </a>
      {/each}
    </div>
  </div>
</div>

<style lang="postcss">
  img {
    max-width: 9rem;
    max-height: 5rem;
  }
</style>
